import { Box, BoxProps, ColorOptions, IconNew, Text } from '@jfs/ui-new'
import { ReactNode, useEffect, useState } from 'react'

const ExpandAddView = ({
  title,
  children,
  isExpand = false,
  setIsExpand,
  testID = '',
}: {
  title: string
  children: ReactNode
  isExpand?: boolean
  setIsExpand?: any
  testID?: string
}) => {
  const [toggle, setToggle] = useState(isExpand)
  useEffect(() => {
    setToggle(isExpand)
  }, [isExpand])

  const toggleView = () => {
    setIsExpand && setIsExpand((prev) => !prev)
    setToggle((prev) => !prev)
  }
  return (
    <Box>
      <Box
        onPress={toggleView}
        {...styles.subcontainer}
        borderBottomLeftRadius={toggle ? 0 : 4}
        borderBottomRightRadius={toggle ? 0 : 4}
        bg={toggle ? ('#f8f9fc' as ColorOptions) : 'WHITE'}>
        <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} testID={testID + '-title'}>
          {title}
        </Text>
        <IconNew
          id={toggle ? 'ARROW_DOWN' : 'ARROW_RIGHT'}
          size="FONT_SIZE_EXTRA_LARGE"
          color={'#d1d3e2' as ColorOptions}
          weight={'dense'}
        />
      </Box>
      {toggle ? children : null}
    </Box>
  )
}

export { ExpandAddView }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  subcontainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
